import { cn } from "@omni/utils/styles";

import { useDeliveryItemContext } from "@/components/Product/ECommerce/components/delivery/components/deliveryTypes/deliveryItem/context/deliveryItem.context";
import { useGranite } from "@/redux/modules/value/translations/translations.provider";

type Props = {
    className?: string;
};

export const LimitedStock = ({ className }: Props) => {
    const { t } = useGranite();

    const { isLimitedStock } = useDeliveryItemContext();

    if (!isLimitedStock) return null;

    return (
        <p className={cn("tw:text-sm tw:font-light tw:m-0", className)}>
            {t("general.ecommerce.clickAndCollect.limitedStock")}
        </p>
    );
};
